var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPnlUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37057 2.10192e-07C4.58618 0.000155265 4.79288 0.0860359 4.94511 0.238716L7.76336 3.06517C8.08007 3.3828 8.07933 3.89704 7.76169 4.21375C7.44406 4.53047 6.92982 4.52972 6.6131 4.21208L4.36916 1.96161L2.11792 4.21291C1.80075 4.53009 1.28651 4.5301 0.969335 4.21293C0.652156 3.89576 0.652148 3.38152 0.969317 3.06434L3.79568 0.237889C3.94814 0.0854285 4.15496 -0.000154797 4.37057 2.10192e-07Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36979 0C4.81834 0 5.18197 0.363623 5.18197 0.812175V7.18783C5.18197 7.63638 4.81834 8 4.36979 8C3.92124 8 3.55762 7.63638 3.55762 7.18783V0.812175C3.55762 0.363623 3.92124 0 4.36979 0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnlUp);
export default __webpack_public_path__ + "static/media/pnl_up.fceba5dde94803b65f428bdfabbf3ec2.svg";
export { ForwardRef as ReactComponent };